"use strict";

exports.concatString = function (s1) {
  return function (s2) {
    return s1 + s2;
  };
};

exports.concatArray = function (xs) {
  return function (ys) {
    if (xs.length === 0) return ys;
    if (ys.length === 0) return xs;
    return xs.concat(ys);
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Semigroup/foreign.js
// module id = 289
// module chunks = 0